<div class="mb-5" [ngClass]="{ ' ar': translate.currentLang === 'ar' }">
  <div class="searchBox">
    <form [formGroup]="flightSearch.searchFlight" class="SearchForm">
      <div
        class="flight-type-buttons"
        [ngClass]="{ ' ar': translate.currentLang === 'ar' }"
      >
        <div
          class="flight-type row mt-3 justify-content-between flex-wrap-reverse"
        >
          <mat-radio-group
            aria-label="Flight-Type"
            formControlName="flightType"
            class="col-12 col-lg-6"
          >
            <mat-radio-button value="OneWay" class="one-way-radio">{{
              "searchbox.oneWay" | translate
            }}</mat-radio-button>
            <mat-radio-button value="RoundTrip" class="roundtrip-radio">{{
              "searchbox.roundTrip" | translate
            }}</mat-radio-button>
            <mat-radio-button value="MultiCity" class="multicity-radio">{{
              "searchbox.multiCity" | translate
            }}</mat-radio-button>
          </mat-radio-group>

          <div
            class="col-12 col-lg-3 mt-2 d-flex justify-content-center align-items-start"
          >
            <img
              *ngIf="airlineLogo"
              [src]="airlineLogo"
              title="Airline logo"
              class="airline-logo"
            />
          </div>
        </div>
      </div>

      <div class="searchBox-form mt-3">
        <app-one-way
          *ngIf="flightSearch.searchFlight.get('flightType')?.value == 'OneWay'"
        ></app-one-way>
        <app-round-trip
          *ngIf="
            flightSearch.searchFlight.get('flightType')?.value == 'RoundTrip'
          "
        ></app-round-trip>
        <app-multi-city
          *ngIf="
            flightSearch.searchFlight.get('flightType')?.value == 'MultiCity'
          "
        ></app-multi-city>
      </div>
    </form>
  </div>
</div>
